// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prompt-rotate[data-v-3e459564]{margin:0}.card-title h4[data-v-3e459564]{margin-bottom:0}.buttons[data-v-3e459564]{display:flex;justify-content:flex-end;width:100%}", ""]);
// Exports
module.exports = exports;
